import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import Cookies from "js-cookie";

const env = require("./env.json");

const isLocalDev = env.BUILD_ENV === "local";
const isStaging = env.BUILD_ENV !== "production";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ extensions }) => {
      if (extensions.code === "UNAUTHENTICATED") {
        console.log("AUTH");
      }
    });
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const httpLink = createHttpLink({
  uri: isLocalDev ? "http://192.168.1.15:8881/graphql" : `https://${isStaging ? "staging." : ""}api-client.common-ground.io/graphql`
});
const authLink = setContext((_, { headers = {} }) => {
  const jwt = Cookies.get("jwt");
  if (jwt) headers["commonground-jwt"] = jwt;

  headers["commonground-origin"] = env.ORIGIN;
  return { headers };
});

const cache = new InMemoryCache({
  typePolicies: {
    ItemLabel: { keyFields: ["catno", "id"] },
    ItemArtist: { keyFields: ["id", "name"] },
    Track: { keyFields: ["title", "position", "uri"] },
    ThemeColorPreset: { keyFields: ["name", "value"] },
    Checkout: {
      fields: {
        items: {
          merge (existing, incoming) {
            return incoming;
          }
        }
      }
    }
  }
});

const apolloClient = new ApolloClient({
  link: from([errorLink, authLink, httpLink]),
  cache
});

export {
  apolloClient
};
